import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

const formatInstant = (iso: string) =>
  new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });

/**
 * Every decision ever recorded for this engagement.
 *
 * Approvals are append-only, so a reversal appears as a second entry rather than replacing
 * the first — the trail shows what was decided and when, not just the current answer.
 */
export function ApprovalHistory({ engagementId }: { engagementId: string }) {
  const history = useQuery({
    queryKey: ['approvalHistory', engagementId],
    queryFn: () => api.listApprovals(engagementId),
  });

  const items = [...(history.data?.items ?? [])].sort((a, b) => b.at.localeCompare(a.at));
  if (history.isLoading || items.length === 0) return null;

  return (
    <section className="card panel" aria-labelledby="hist-title">
      <h2 id="hist-title" className="panel-title">
        Decisions
      </h2>
      <div className="run-list">
        {items.map((a) => (
          <article key={a.id} className="run">
            <div className="run-head">
              <span>
                {a.gate} gate · scope v{a.scopeVersion}
              </span>
              <span
                className={`status ${a.decision === 'APPROVED' ? 'status-done' : 'status-waiting'}`}
              >
                {a.decision}
              </span>
            </div>
            <p className="meta">
              {formatInstant(a.at)} · <span className="mono">{a.approverUserId}</span>
            </p>
            {a.note ? <p className="meta">“{a.note}”</p> : null}
          </article>
        ))}
      </div>
    </section>
  );
}
